<template>
  <div>
    <h1>메인 화면 배너<small class="ml-3 text-muted">{{ banner.id > 0 ? '수정' : '추가'}}</small></h1>
    <div class="card" v-if="banner !== null">
      <div class="card-body">
        <div class="form-group">
          <label for="banner-title">제목</label>
          <input type="text" class="form-control"
                 id="banner-title"
                 placeholder=""
                 v-model="banner.title"
                 name="banner-title"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-title')}">
          <div class="invalid-feedback" v-if="errors.has('banner-title')">{{errors.first('banner-title')}}</div>
        </div>
        <div class="form-group">
          <label for="banner-description">설명</label>
          <input type="text" class="form-control"
                 id="banner-description"
                 placeholder=""
                 v-model="banner.description"
                 name="banner-description"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-description')}">
          <div class="invalid-feedback" v-if="errors.has('banner-description')">{{errors.first('banner-description')}}</div>
        </div>
        <div class="form-group">
          <label for="banner-order">배너 순서</label>
          <input type="text" class="form-control"
                 id="banner-order"
                 placeholder=""
                 v-model="banner.orderNo"
                 name="banner-order"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-order')}">
          <div class="invalid-feedback" v-if="errors.has('banner-order')">{{errors.first('banner-order')}}</div>
        </div>
        <div class="form-group">
          <label>링크 버튼 공개 여부</label>
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="banner-link-visible-true" name="banner-link-visible" class="custom-control-input" :value="true"
                     v-model="banner.linkVisible">
              <label class="custom-control-label" for="banner-link-visible-true">공개</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="banner-link-visible-false" name="banner-link-visible" class="custom-control-input" :value="false"
                     v-model="banner.linkVisible">
              <label class="custom-control-label" for="banner-link-visible-false">비공개</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="banner-link-text">링크 텍스트</label>
          <input type="text" class="form-control"
                 id="banner-link-text"
                 placeholder=""
                 v-model="banner.linkText"
                 name="banner-link-text"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-link-text')}">
          <div class="invalid-feedback" v-if="errors.has('banner-link-text')">{{errors.first('banner-link-text')}}</div>
        </div>
        <div class="form-group">
          <label for="banner-link-url">링크 URL</label>
          <input type="text" class="form-control"
                 id="banner-link-url"
                 placeholder=""
                 v-model="banner.linkUrl"
                 name="banner-link-url"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-link-url')}">
          <div class="invalid-feedback" v-if="errors.has('banner-link-url')">{{errors.first('banner-link-url')}}</div>
        </div>
        <div class="form-group">
          <label for="banner-text-color">텍스트 컬러</label>
          <input type="text" class="form-control"
                 id="banner-text-color"
                 placeholder=""
                 v-model="banner.textColor"
                 name="banner-text-color"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('banner-text-color')}">
          <div class="invalid-feedback" v-if="errors.has('banner-text-color')">{{errors.first('banner-text-color')}}</div>
        </div>
        <div class="form-group">
          <label>공개 여부</label>
          <div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="banner-status-true" name="banner-status" class="custom-control-input" :value="true"
                     v-model="banner.status">
              <label class="custom-control-label" for="banner-status-true">공개</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="banner-status-false" name="banner-status" class="custom-control-input" :value="false"
                     v-model="banner.status">
              <label class="custom-control-label" for="banner-status-false">비공개</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>
            배경 이미지(PC)
            <small v-if="banner.img1 !== null && banner.img1 !== ''" class="text-muted ml-3">{{banner.img1}}</small>
          </label>
          <p><img v-if="banner.img1 !== ''" :src="`${publicPath}upload/main_banner/${banner.img1}`" class="img-fluid mb-3"/></p>
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="banner-image1" name="banner-image1" ref="bannerImage1" accept="image/*"
                   @change="handleImage(1)">
            <label class="custom-file-label" for="banner-image1">
              {{ this.img1 !== null ? this.img1.name : 'Choose file'}}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label>
            배경 이미지(Mobile)
            <small v-if="banner.img2 !== null && banner.img2 !== ''" class="text-muted ml-3">{{banner.img2}}</small>
          </label>
          <p><img v-if="banner.img2 !== ''" :src="`${publicPath}upload/main_banner/${banner.img2}`" class="img-fluid mb-3"/></p>
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="banner-image2" name="banner-image2" ref="bannerImage2" accept="image/*"
                   @change="handleImage(2)">
            <label class="custom-file-label" for="banner-image2">
              {{ this.img2 !== null ? this.img2.name : 'Choose file'}}
            </label>
          </div>
        </div>
      </div>


    </div>

    <div class="text-center my-5">
      <button type="button" class="btn btn-outline-secondary mx-2" @click="submit">저장</button>
      <button type="button" class="btn btn-outline-secondary mx-2" @click="$router.back()">취소</button>
    </div>

  </div>
</template>

<script>

export default {
  name: 'AdminMainWrite',
  data() {
    return {
      banner: {
        id: 0,
        title: '',
        description: '',
        linkText: '',
        linkUrl: '',
        linkVisible: false,
        orderNo: 0,
        img1: '',
        img2: '',
        status: false,
        textColor: '#ffffff',
      },
      img1: null,
      img2: null,
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/main/${this.$route.params.id}`)
        .then(({ data }) => {
          this.banner = data;
        });
    } else {
      this.banner = {
        title: '',
        description: '',
        linkText: '',
        linkUrl: '',
        linkVisible: false,
        orderNo: 0,
        img1: '',
        img2: '',
        status: false,
        textColor: '#ffffff',
      };
    }
  },
  methods: {
    handleImage(no) {
      if (no === 1) {
        this.img1 = this.$refs.bannerImage1.files.length ? this.$refs.bannerImage1.files[0] : null;
      } else if (no === 2) {
        this.img2 = this.$refs.bannerImage2.files.length ? this.$refs.bannerImage2.files[0] : null;
      }
    },
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      const formData = new FormData();

      if (this.banner.id) {
        formData.append('id', this.banner.id);
      }
      formData.append('title', this.banner.title);
      formData.append('description', this.banner.description);
      formData.append('linkText', this.banner.linkText);
      formData.append('linkUrl', this.banner.linkUrl);
      formData.append('linkVisible', this.banner.linkVisible);
      formData.append('orderNo', this.banner.orderNo);
      formData.append('status', this.banner.status);
      formData.append('textColor', this.banner.textColor);

      if (this.img1) { formData.append('img1', this.img1); }
      if (this.img2) { formData.append('img2', this.img2); }

      this.$axios({ url: '/admin/main', method: this.banner.id > 0 ? 'PUT' : 'POST', data: formData })
        .then(() => {
          this.$router.push({ name: 'adminMainList' });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>

</style>
